import React, { useEffect, useRef, useState } from 'react';
import style from '../../../assets/styles/ReportFilterModal.module.css';
import closeIcon from '../../../assets/images/closeSvgIcon.svg';
import filterIcon from '../../../assets/images/filter.png';
import plusTag from '../../../assets/images/blackPlusTag.svg';
import {
  CREATE_REPORT,
  GET_FREE_TAG,
  GET_REPORT_AUTHORLIST,
  GET_REPORT_CATEGORYLIST,
  GET_REPORT_QUESTIONTYPE,
} from '../../../action/apiPath';
import { CallWithAuth } from '../../../action/apiActions';
import { useToast } from '../../molecule/common/Toast';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
interface ReportFilterModalProps {
  isOpen: boolean;
  onClose: () => void;
}
interface QuestionType {
  id: number;
  name: string;
  category: string;
}
interface Category {
  id: number;
  name: string;
  category?: string;
  cat_name?: string;
}
interface FreeTag {
  id: number;
  name: string;
  tag_name?: string;
}
interface Author {
  id?: number;
  user_id?: number;
  name: string;
}
const ReportFilterModal: React.FC<ReportFilterModalProps> = ({ isOpen, onClose }) => {
  const toast = useToast();
  const [selectedYear, setSelectedYear] = useState<number | string>('');
  const [selectedYearExclude, setSelectedYearExclude] = useState<number | string>('');
  const { reportQuestionbank } = useSelector((state: any) => state.GetAllData);
  const [getFreeTag, setGetFreeTag] = useState<FreeTag[]>([]);
  const [freeTagStatus, setFreeTagStatus] = useState(false);
  // Modified to store full object
  const [selectedFreeTag, setSelectedFreeTag] = useState<FreeTag[]>([]);
  const [questionTypes, setQuestionTypes] = useState<QuestionType[]>([]);
  const searchTimeout = useRef<NodeJS.Timeout | null>(null);
  // Modified to store full object
  const [selectedOptions, setSelectedOptions] = useState<QuestionType[]>([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  // Modified to store full object
  const [selectedCategory, setSelectedCategory] = useState<Category[]>([]);
  const [isCategoryDropdownOpen, setIsCategoryDropdownOpen] = useState(false);
  const [categoryList, setCategoryList] = useState<Category[]>([]);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const CategorydropdownRef = useRef<HTMLDivElement>(null);
  const [selectQuestionBank, setSelectQuestionBank] = useState<number | string>('');
  const organizationId = localStorage.getItem('selectedOrgId');
  const [authorInput, setAuthorInput] = useState('');
  const [tagInput, setTagInput] = useState('');
  const [authorList, setAuthorList] = useState<Author[]>([]);
  const [authorStatus, setAuthorStatus] = useState(false);
  const [selectedAuthor, setSelectedAuthor] = useState<Author[]>([]);
  const freeTagRef = useRef<HTMLDivElement>(null);
  const authorRef = useRef<HTMLDivElement>(null);
  const [searchKeyword, setSearchKeyword] = useState<string>('');
  const { id } = useParams();
  const BASE_URL = process.env.REACT_APP_API_KEY;
  const [initialData, setInitialData] = useState<any>(null);
  // Added loading state to prevent multiple submissions
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const fetchReportDetails = async () => {
    const response = await CallWithAuth('GET', `${BASE_URL}reports/${id}/get-distribution-report-details/`);
    if (response.status && response.res && response.res.status === 200) {
      const data = response.res?.data.data || {};
      setInitialData(data);
      // Populate the state variables with the fetched data
      setSearchKeyword(data.search_keyword || '');
      setSelectQuestionBank(data.question_bank || '');
      setSelectedOptions(data.question_types ? data.question_types : []);
      setSelectedYear(data.academic_year_from || '');
      setSelectedYearExclude(data.academic_year_to || '');
      setSelectedCategory(data.categories ? data.categories : []);
      setSelectedFreeTag(data.free_tags ? data.free_tags : []);
      setSelectedAuthor(data.authors ? data.authors : []);
    }
  };
  useEffect(() => {
    if (id !== null && id !== undefined) {
      fetchReportDetails();
    }
  }, [id]);

  // Update the input field handler for the Subject/Area/Topic/Sub-topic
  const handleSearchKeywordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchKeyword(e.target.value);
  };

  //select year after
  const getYearAfter = () => {
    return {
      color: selectedYear ? 'black' : '#808080',
      width: '100%',
    };
  };
  const getYearBefore = () => {
    return {
      color: selectedYearExclude ? 'black' : '#808080',
      width: '100%',
    };
  };
  const getQuestionBankStyle = () => {
    return {
      color: selectQuestionBank ? 'black' : '#808080',
      width: '100%',
    };
  };
  const handleQuestionBankChange = (e: any) => {
    setSelectQuestionBank(e.target.value);
  };
  const GetReportQuestionType = async (): Promise<void> => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const GetData: any = await CallWithAuth('GET', GET_REPORT_QUESTIONTYPE);
    if (GetData?.status && Array.isArray(GetData?.res?.data)) {
      setQuestionTypes(GetData.res.data);
    }
  };
  const GetReportCategoryList = async (): Promise<void> => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const GetData: any = await CallWithAuth('GET', GET_REPORT_CATEGORYLIST + organizationId + '/');
    if (GetData?.status && Array.isArray(GetData?.res?.data)) {
      setCategoryList(GetData.res.data);
    }
  };
  useEffect(() => {
    GetReportQuestionType();
    GetReportCategoryList();
  }, []);
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
      if (CategorydropdownRef.current && !CategorydropdownRef.current.contains(event.target as Node)) {
        setIsCategoryDropdownOpen(false);
      }
      if (freeTagRef.current && !freeTagRef.current.contains(event.target as Node)) {
        setFreeTagStatus(false);
      }
      if (authorRef.current && !authorRef.current.contains(event.target as Node)) {
        setAuthorStatus(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (!isOpen) return null; // Render nothing when modal is closed

  // Create an array of years from 2000 to 20 years after the current year
  const yearOptions = [];
  const currentYear = new Date().getFullYear();
  for (let year = 2000; year <= currentYear + 20; year++) {
    yearOptions.push(year);
  }

  // Event handler for changing the selected year
  const handleYearChangeUsed = (e: any) => {
    setSelectedYear(parseInt(e.target.value, 10));
  };

  // Event handler for changing the selected year
  const handleYearChangeExclude = (e: any) => {
    setSelectedYearExclude(parseInt(e.target.value, 10));
  };

  // Toggle questionType dropdown visibility
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // Handle selecting/deselecting checkboxes - MODIFIED to store full object
  const handleCheckboxChange = (option: QuestionType) => {
    setSelectedOptions((prev) => {
      const exists = prev.some((item) => item.id === option.id);
      if (exists) {
        return prev.filter((item) => item.id !== option.id);
      } else {
        return [...prev, option];
      }
    });
  };

  // MODIFIED to remove by id
  const handleRemove = (optionId: number) => {
    setSelectedOptions((prev) => prev.filter((item) => item.id !== optionId));
  };

  //category handle
  // Toggle questionType dropdown visibility
  const toggleCategoryDropdown = () => {
    setIsCategoryDropdownOpen(!isCategoryDropdownOpen);
  };

  // Handle selecting/deselecting checkboxes - MODIFIED to store full object
  const handleCategoryCheckboxChange = (option: Category) => {
    setSelectedCategory((prev) => {
      const exists = prev.some((item) => item.id === option.id);
      if (exists) {
        return prev.filter((item) => item.id !== option.id);
      } else {
        return [...prev, option];
      }
    });
  };

  // MODIFIED to remove by id
  const handleCategoryRemove = (optionId: number) => {
    setSelectedCategory((prev) => prev.filter((item) => item.id !== optionId));
  };

  // Function to close the modal
  const closeModal = () => {
    onClose(); // Notify parent component
  };

  // Handle manual freetags input changes
  const handleFreeTagInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setTagInput(value);
    setFreeTagStatus(false);
    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    setTimeout(() => {
      getFreeTags(value);
    }, 300);
  };
  // CALL GET API FOR getting FREE TAGS
  const getFreeTags = async (value: any) => {
    if (value.length > 2) {
      const data = await CallWithAuth('GET', GET_FREE_TAG + '?keyword=' + value);
      if (data.status && data.res && data.res.status === 200) {
        setGetFreeTag(data.res.data || []);
        setFreeTagStatus(true);
      }
    } else {
      setFreeTagStatus(false);
      setGetFreeTag([]);
    }
  };

  // MODIFIED to use full object
  const handleTagCheckboxChange = (tag: FreeTag) => {
    setSelectedFreeTag((prev) => {
      const exists = prev.some((item) => item.id === tag.id);
      if (exists) {
        return prev.filter((item) => item.id !== tag.id);
      } else {
        return [...prev, tag];
      }
    });
  };

  // MODIFIED to remove by id
  const handleRemoveTags = (tagId: number) => {
    setSelectedFreeTag((prev) => prev.filter((item) => item.id !== tagId));
  };

  // Handle author input changes
  const handleAuthorInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setAuthorInput(value);
    setAuthorStatus(false);
    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    setTimeout(() => {
      getAuthorList(value);
    }, 300);
  };
  // CALL GET API FOR getting FREE TAGS
  const getAuthorList = async (value: any) => {
    if (value.length > 2) {
      const data = await CallWithAuth('GET', GET_REPORT_AUTHORLIST + organizationId + '/?keyword=' + value);
      if (data.status && data.res && data.res.status === 200) {
        setAuthorList(data?.res?.data || []);
        setAuthorStatus(true);
      }
    } else {
      setAuthorStatus(false);
      setAuthorList([]);
    }
  };

  // MODIFIED to use full object
  const handleAuthorCheckbox = (author: Author) => {
    setSelectedAuthor((prev) => {
      const authorId = author.id ?? author.user_id;
      const exists = prev.some((item) => (item.id ?? item.user_id) === authorId);
      if (exists) {
        return prev.filter((item) => (item.id ?? item.user_id) !== authorId);
      } else {
        return [...prev, author];
      }
    });
  };

  // MODIFIED to remove by id
  const handleRemoveAuthor = (authorId: number) => {
    setSelectedAuthor((prev) => prev.filter((item) => (item.id ?? item.user_id) !== authorId));
  };

  const handleSaveFilter = async () => {
    // If already submitting, prevent multiple submissions
    if (isSubmitting) {
      return;
    }
    try {
      // Set isSubmitting to true to disable the button
      setIsSubmitting(true);

      // No need for extra formatting since we're storing full objects
      const formattedQuestionTypes = selectedOptions.map((type) => ({
        id: type.id,
        name: type.name,
      }));

      // Format categories with proper structure
      const formattedCategories = selectedCategory.map((cat: any) => ({
        cat_id: cat.id || cat.cat_id,
        cat_name: cat.cat_name || cat.name,
      }));

      // Format free tags with proper structure
      const formattedTags = selectedFreeTag.map((tag: any) => ({
        tag_id: tag.id || tag.tag_id,
        tag_name: tag.tag_name || tag.name,
      }));

      // Format authors - get IDs
      const formattedAuthors = selectedAuthor.map((author) => author.id ?? author.user_id);

      // Create the request payload
      const payload = {
        org_id: Number(organizationId),
        search_keyword: searchKeyword,
        question_bank: Number(selectQuestionBank),
        question_types: formattedQuestionTypes,
        academic_year_from: selectedYear !== '' ? selectedYear : null,
        academic_year_to: selectedYearExclude !== '' ? selectedYearExclude : null,
        categories: formattedCategories,
        free_tags: formattedTags,
        authors: formattedAuthors,
      };
      // Make API request using your CallWithAuth function
      const response = await CallWithAuth('POST', CREATE_REPORT, payload);

      if (response.status && response.res && response.res.status === 201) {
        toast?.add(response.res?.data?.message, 'success');
        onClose();
      } else {
        // Handle error responses
        const errorMessage = response.res?.data?.error || 'Failed to create report';
        toast?.add(errorMessage, 'error');
      }
    } catch (error) {
      console.log('An error occurred while creating the report');
    } finally {
      // Set isSubmitting back to false regardless of success or failure
      setIsSubmitting(false);
    }
  };

  const handleResetFilter = () => {
    if (id && initialData) {
      // Reset fields to fetched data
      setSearchKeyword(initialData.search_keyword || '');
      setSelectQuestionBank(initialData.question_bank || '');
      // Reset with full objects
      setSelectedOptions(initialData.question_types || []);
      setSelectedYear(initialData.academic_year_from || '');
      setSelectedYearExclude(initialData.academic_year_to || '');
      setSelectedCategory(initialData.categories || []);
      setSelectedFreeTag(initialData.free_tags || []);
      setSelectedAuthor(initialData.authors || []);
    } else {
      // Clear all fields if no report id (new report)
      setSearchKeyword('');
      setSelectQuestionBank('');
      setSelectedOptions([]);
      setSelectedYear('');
      setSelectedYearExclude('');
      setSelectedCategory([]);
      setSelectedFreeTag([]);
      setSelectedAuthor([]);
      setTagInput('');
      setAuthorInput('');
    }
  };

  return (
    <button
      className={style.Report_modal_overlay}
      onClick={closeModal}
      onKeyDown={(e) => e.key === 'Escape' && closeModal()}
      style={{ border: 'none', padding: '0px' }}
    >
      <button
        className={style.modal_content}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
        style={{ border: 'none', padding: '0px' }}
      >
        <div className={style.ReportModalHeader}>
          <div className={style.modal_title}>
            <span className={style.filterIconWrap}>
              <img src={filterIcon} alt="Filter" />
            </span>
            <span className={style.title}>Filter</span>
          </div>
          <div className={style.modal_close_new}>
            <button
              onKeyDown={(e) => {
                if (e.key === 'Enter') onClose();
              }}
              className={style.modalClose}
              onClick={onClose}
            >
              <img src={closeIcon} alt="Close" />
            </button>
          </div>
        </div>
        <div className={style.Report_modal_body}>
          <div className={style.filter_div}>
            <div className={style.filter_section} style={{ width: '45%' }}>
              <label htmlFor="searchSubjectTags">Subject | Area | Topic | Sub-topic</label>
              <span className={style.filter_input} style={{ width: '96%', padding: '0px' }}>
                <input
                  id="searchSubjectTags"
                  className={style.filter_Subjectinput}
                  type="text"
                  autoComplete="off"
                  placeholder="Search tags"
                  value={searchKeyword}
                  onChange={handleSearchKeywordChange}
                />
              </span>
            </div>
            <div className={style.filter_section} style={{ width: '45%' }}>
              <label htmlFor="questionBankSelect">
                Question Bank <span className={style.required_field}>*</span>
              </label>
              <div className={style.custom_select} style={{ width: '95%' }}>
                <select
                  id="questionBankSelect"
                  style={getQuestionBankStyle()}
                  value={selectQuestionBank}
                  onChange={handleQuestionBankChange}
                >
                  <option>Select question bank</option>
                  {reportQuestionbank?.map((items: any, i: any) => (
                    <option key={i + 1} value={items.id}>
                      {items.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className={`${style.filter_section} ${style.filter_section_new}`} ref={dropdownRef}>
            <label htmlFor="QuestionType">Question Type</label>
            <button
              className={`${style.custom_select} ${style.custom_select_new} ${style.custom_multiselect}`}
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              id="QuestionType"
              style={{ border: 'none', background: 'none', padding: '0px' }}
            >
              <img src={plusTag} alt="Plus tag" className={style.plusIcon} />
              <button
                className={style.dropdown_header}
                onClick={toggleDropdown}
                style={{ width: '100%', height: '50px', background: 'none' }}
              >
                Select type
              </button>
            </button>
            {isDropdownOpen && (
              <div className={style.dropdown_menu} aria-labelledby="questionTypeLabel">
                {questionTypes.map((type) => (
                  <label key={type.id} className={style.dropdown_item}>
                    <label className="custom-checkbox" aria-label="Has Timer">
                      <input
                        type="checkbox"
                        checked={selectedOptions.some((item) => item.id === type.id)}
                        onChange={() => handleCheckboxChange(type)}
                      />
                      <span className="checkmark"></span>
                    </label>
                    {type.name}
                  </label>
                ))}
              </div>
            )}
          </div>

          <div className={style.filters_container} style={{ display: selectedOptions.length <= 0 ? 'none' : 'flex' }}>
            {selectedOptions.map((option) => (
              <div key={option.id} className={style.selected_filters_label}>
                <span className={style.label_text}>{option.name}</span>
                <button
                  onKeyDown={(e) => e.key === 'Enter' && handleRemove(option.id)}
                  className={style.modalClose}
                  onClick={() => handleRemove(option.id)}
                >
                  <img src={closeIcon} alt="Close" />
                </button>
              </div>
            ))}
          </div>

          <div className={style.filter_section_row}>
            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: '15px' }}>
              <div className={style.filter_section_div1} style={{ width: '18vw' }}>
                <label htmlFor="SelectYearAfter">Include Question Used in or After</label>
                <div className={style.custom_select} style={{ width: '17vw' }}>
                  <select
                    id="SelectYearAfter"
                    style={getYearAfter()}
                    value={selectedYear}
                    onChange={handleYearChangeUsed}
                  >
                    <option value="">Select year</option>
                    {yearOptions.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className={style.filter_section_div1} style={{ width: '18vw' }}>
                <label htmlFor="SelectYearBefore">Include Question Used in or Before</label>
                <div className={style.custom_select} style={{ width: '17vw' }}>
                  <select
                    id="SelectYearBefore"
                    style={getYearBefore()}
                    value={selectedYearExclude}
                    onChange={handleYearChangeExclude}
                  >
                    <option value="">Select year</option>
                    {yearOptions.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', width: '25vw' }}>
                <div className={style.filter_section} ref={CategorydropdownRef}>
                  <label htmlFor="categoryTagsBtn">Category</label>
                  <button
                    id="categoryTagsBtn"
                    className={`${style.Categorycustom_select} ${style.custom_select_new} ${style.custom_multiselect}`}
                    onClick={() => setIsCategoryDropdownOpen(!isCategoryDropdownOpen)}
                    style={{ border: 'none', background: 'none', padding: '0px' }}
                  >
                    <img src={plusTag} alt="Plus tag" className={style.plusIcon} />
                    <button
                      className={style.Categoryheader}
                      onClick={toggleCategoryDropdown}
                      style={{ height: '50px', width: '23vw', background: 'none' }}
                    >
                      Select Category
                    </button>
                  </button>
                  {isCategoryDropdownOpen && (
                    <div className={style.categoryDropdown_Menu}>
                      {categoryList.map((type) => (
                        <label key={type.id} className={style.dropdown_item}>
                          <label className="custom-checkbox" aria-label="Has Timer">
                            <input
                              type="checkbox"
                              checked={selectedCategory.some((item) => item.id === type.id)}
                              onChange={() => handleCategoryCheckboxChange(type)}
                            />
                            <span className="checkmark"></span>
                          </label>
                          {type.name || type.cat_name}
                        </label>
                      ))}
                    </div>
                  )}
                </div>
                <div
                  className={style.filters_container}
                  style={{ display: selectedCategory.length <= 0 ? 'none' : 'flex' }}
                >
                  {selectedCategory.map((option: any) => (
                    <div key={option.id} className={style.selected_filters_label}>
                      <span className={style.label_text} style={{ width: '80px', overflowWrap: 'break-word' }}>
                        {option.cat_name || option.name}
                      </span>
                      <button
                        onKeyDown={(e) => e.key === 'Enter' && handleCategoryRemove(option.id)}
                        className={style.modalClose}
                        onClick={() => handleCategoryRemove(option.id)}
                      >
                        <img src={closeIcon} alt="Close" />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className={style.filter_div}>
            <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '48%' }}>
                <div className={style.filter_section} ref={freeTagRef}>
                  <label htmlFor="SelectTag">Tags</label>
                  <div className={`${style.custom_input}`}>
                    <img src={plusTag} alt="Plus tag" className={style.plusIcon} style={{ top: '42px' }} />
                    <input
                      type="search"
                      id="SelectTag"
                      placeholder="Search tags"
                      value={tagInput}
                      onChange={(e) => handleFreeTagInput(e)}
                      autoComplete="off"
                      list="autocompleteoff"
                      style={{ width: '92%' }}
                    />
                  </div>
                  {freeTagStatus && getFreeTag.length > 0 && (
                    <div className={style.Tagsdropdown_menu}>
                      {getFreeTag?.map((tag: FreeTag) => (
                        <label key={tag.id} className={style.dropdown_item}>
                          <label className="custom-checkbox" aria-label="Has Timer">
                            <input
                              type="checkbox"
                              checked={selectedFreeTag.some((item) => item.id === tag.id)}
                              onChange={() => handleTagCheckboxChange(tag)}
                            />
                            <span className="checkmark"></span>
                          </label>
                          {tag.name || tag.tag_name}
                        </label>
                      ))}
                    </div>
                  )}
                </div>
                <div
                  className={style.filters_container}
                  style={{ display: selectedFreeTag.length <= 0 ? 'none' : 'flex' }}
                >
                  {selectedFreeTag.map((option) => (
                    <div key={option.id} className={style.selected_filters_label}>
                      <span className={style.label_text}>{option?.tag_name ?? option?.name}</span>
                      <button
                        onKeyDown={(e) => e.key === 'Enter' && handleRemoveTags(option.id)}
                        className={style.modalClose}
                        onClick={() => handleRemoveTags(option.id)}
                      >
                        <img src={closeIcon} alt="Close" />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                <div className={style.filter_section} ref={authorRef}>
                  <label htmlFor="SelectAuthor">Question Author(s)</label>
                  <div className={`${style.custom_input}`}>
                    <img src={plusTag} alt="Plus tag" className={style.plusIcon} style={{ top: '42px' }} />
                    <input
                      type="search"
                      id="SelectAuthor"
                      placeholder="Search author(s)"
                      onChange={(e) => handleAuthorInput(e)}
                      autoComplete="off"
                      list="autocompleteoff"
                      value={authorInput}
                      style={{ width: '90%' }}
                    />
                  </div>
                  {authorStatus && authorList?.length > 0 && (
                    <div className={style.Authordropdown_menu}>
                      {authorList?.map((author: Author) => {
                        const authorId = author?.id ?? author?.user_id;
                        return (
                          <label key={authorId} className={style.dropdown_item}>
                            <label className="custom-checkbox" aria-label="Has Timer">
                              <input
                                type="checkbox"
                                checked={selectedAuthor.some((item) => (item?.id ?? item?.user_id) === authorId)}
                                onChange={() => handleAuthorCheckbox(author)}
                              />
                              <span className="checkmark"></span>
                            </label>
                            {author.name}
                          </label>
                        );
                      })}
                    </div>
                  )}
                </div>
                <div
                  className={style.filters_container}
                  style={{ display: selectedAuthor.length <= 0 ? 'none' : 'flex' }}
                >
                  {selectedAuthor.map((option) => {
                    const authorId = option?.id ?? option?.user_id;
                    return (
                      <div key={authorId} className={style.selected_filters_label}>
                        <span className={style.label_text}>{option.name}</span>
                        <button
                          onKeyDown={(e) => e.key === 'Enter' && handleRemoveAuthor(authorId as number)}
                          className={style.modalClose}
                          onClick={() => handleRemoveAuthor(authorId as number)}
                        >
                          <img src={closeIcon} alt="Close" />
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={style.action_buttons}>
          <button className={style.reset_button} onClick={handleResetFilter} disabled={isSubmitting}>
            Reset Filter
          </button>
          <button
            className={style.blue_button}
            type="submit"
            onClick={handleSaveFilter}
            disabled={isSubmitting}
            style={{ opacity: isSubmitting ? 0.7 : 1, cursor: isSubmitting ? 'not-allowed' : 'pointer' }}
          >
            {isSubmitting ? 'Applying...' : 'Apply Filter'}
          </button>
        </div>
      </button>
    </button>
  );
};

export default ReportFilterModal;
